import { createContext } from 'react';
import type { AuthState } from './authState';
import { initialAuthState } from './authState';

interface AuthContextInterface extends AuthState {
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

const uninitializedFunction = (): never => {
  throw new Error('It needs to be wrapped in an AuthProvider');
};

const initialAuthContext: AuthContextInterface = {
  ...initialAuthState,
  login: uninitializedFunction,
  logout: uninitializedFunction,
};

export const AuthContext = createContext<AuthContextInterface>(initialAuthContext);
